import { ArrowIcon } from 'components/Icons';
import { Theme } from '@mui/material';

export default {
  defaultProps: {
    separator: <ArrowIcon />,
  },
  styleOverrides: {
    root({ theme }: { theme: Theme }) {
      return {
        ...theme.typography.body2,
        color: theme.palette.grey['700'],
      };
    },
    li({ theme }: { theme: Theme }) {
      return {
        '&:first-of-type': {
          color: theme.palette.common.black,
        },
        a: {
          color: theme.palette.grey['700'],
          textDecoration: 'none',
          '&:first-of-type': {
            color: theme.palette.common.black,
          },
          '&:hover': {
            color: theme.palette.grey['900'],
          },
        },
      };
    },
    separator({ theme }: { theme: Theme }) {
      return {
        color: theme.palette.grey['600'],
        margin: '0 3px',
      };
    },
  },
};
